import { Draggable } from "react-beautiful-dnd";
import Modal from "./Modal";
import TaskDetails from "../../../screens/TaskDetails";
import { Description } from "./Icons";
import ChecklistProgress from "./ChecklistProgress";
import { useState } from "react";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "../../Auth/firebase";
import { extractPriority } from "../../../utils/Boardutils";
import { useProjects } from "../../../context/ProjectsContext";

const Task = ({ allData, id, index, boardId, columnDetails, filterBy }) => {
  const [modal, setModal] = useState(false);
  const theTask = allData.tasks[id];
  const { activeProject } = useProjects();

  const toggleTaskCompletion = async () => {
    try {
      const taskRef = doc(
        db,
        `projects/${activeProject.id}/boards/${boardId}/tasks`,
        id
      );
      await updateDoc(taskRef, {
        completed: !theTask.completed,
      });
      theTask.completed = !theTask.completed;
    } catch (error) {
      console.error("Error updating task:", error);
    }
  };

  let matched = "";

  if (filterBy === null) {
    matched = "all";
  } else {
    matched = theTask.priority === filterBy;
  }

  return (
    <div className={`${matched ? "" : "opacity-10"}`}>
      <Modal modal={modal} setModal={setModal} ariaText="Task Details">
        <TaskDetails
          taskDetails={theTask}
          closeModal={() => setModal(false)}
          boardId={boardId}
          columnDetails={columnDetails}
        />
      </Modal>

      <Draggable draggableId={id} index={index}>
        {(provided, snapshot) => (
          <div
            onClick={() => setModal(true)}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            className={`shadow-lg transition-shadow duration-300 hover:shadow-xl mb-4 rounded px-1.5 py-2.5 ${
              snapshot.isDragging
                ? "bg-gradient-to-r from-red-100 to-blue-100 text-gray-900"
                : "bg-white text-gray-800"
            } ${theTask.completed ? "" : ""}`}
          >
            <div className="flex justify-between items-center w-full">
              <h4 className="text-sm sm:text-base">{theTask.title}</h4>
              <input
                type="checkbox"
                checked={theTask.completed}
                onChange={(e) => {
                  e.stopPropagation();
                  toggleTaskCompletion();
                }}
                className="form-checkbox h-5 w-5 text-blue-600"
              />
            </div>
            <div className="flex mt-2 mb-2 space-x-3 sm:space-x-5">
              {theTask.todos.length >= 1 && (
                <ChecklistProgress todos={theTask.todos} />
              )}
              {extractPriority(theTask.priority)}
              {theTask.description !== null &&
              theTask.description.length > 1 ? (
                <Description />
              ) : null}
            </div>
            {theTask.dueDate && (
              <span className="text-sm text-gray-600">
                <solid className="font-semibold"> Due: </solid>{" "}
                {theTask.dueDate.toDate().toLocaleDateString()}
              </span>
            )}
          </div>
        )}
      </Draggable>
    </div>
  );
};

export default Task;
